function templateStrings(value) {
    if (typeof value === 'string')
        return [value];
    if (!value || typeof value !== 'object')
        return [];
    if ('type' in value && (value.type === 'code' || value.type === 'preformatted'))
        return [];
    return Object.values(value).flatMap(templateStrings);
}
export function validReminderSubstitutions(input) {
    // Normalize Mongoose subdocuments before traversing; code blocks remain literal.
    const content = JSON.parse(JSON.stringify([
        input.title,
        input.useRichFormat ? input.richMessage : input.messageTemplate,
        input.poll,
    ]));
    const text = templateStrings(content).join('\n');
    if (text.includes('{counter}') && !input.substitutions)
        return false;
    for (const match of text.matchAll(/\{date:([^}]*)\}/g)) {
        const offset = /^([+-]\d{1,4})([dw])$/.exec(match[1] ?? '');
        if (!offset || Math.abs(Number(offset[1])) > (offset[2] === 'w' ? 522 : 3660))
            return false;
    }
    return true;
}
//# sourceMappingURL=substitutions.js.map